import router from '@/router/index';
export default {
    authHeaderNoToken: () => {
        return { 'Content-Type': 'application/json' };
    },
    
    authHeaderWithToken: () => {
        let user = JSON.parse(localStorage.getItem('login_info'));
        if (user && user.accessToken && Date.parse(user.expiresTime) > Date.now()) {
            return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.accessToken };
        } else {
            // dispatch('alert/warning', 'Phiên đăng nhập của bạn đã hết, vui lòng đăng nhập lại',{ root: true });
            alert('Phiên đăng nhập của bạn đã hết, vui lòng đăng nhập lại');
            router.push({ path: '/logout' });
        }
    }
};